import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@reach/router';
import { getPage } from 'utils/pages';
import AppButton from 'components/AppButton';
import SectionHeading from 'components/SectionHeading';
import SectionSubtitle from 'components/SectionSubtitle';

const useStyles = makeStyles((theme) => {
  const s = (x) => theme.spacing(x);
  return {
    inner: {
      textAlign: 'center',
      margin: '0 auto',
    },
    bookRepairBtn: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
    headline: {
      color: '#ffffff',
      textTransform: 'uppercase',
      marginBottom: s(2),
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
    },
    subheadline: {
      color: '#FFFFFFCC',
      marginBottom: s(4),
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
    },
  };
});

export const BannerSliderItem = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className="container">
      <Box className={classes.inner}>
        <SectionHeading component="h2" size="medium" className={classes.headline}>{t('Still in love with your favourites?')}</SectionHeading>
        <SectionSubtitle size="large" className={classes.subheadline}>{t('Banner subheadline')}</SectionSubtitle>
        <AppButton className={classes.bookRepairBtn} color="secondary" component={Link} to={`${getPage('product')}${getPage('select')}`} variant="contained">
          {t('BookRepair')}
        </AppButton>
      </Box>
    </div>
  );
};
